import { render, staticRenderFns } from "./SelectJournal.vue?vue&type=template&id=c3ff72b6"
import script from "./SelectJournal.vue?vue&type=script&lang=ts"
export * from "./SelectJournal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports